import React from 'react';
import type { FC } from 'react';
import { css } from '@emotion/react';
import { Link, graphql } from 'gatsby';
import { Layout } from '../components/layout';
// eslint-disable-next-line import/no-unresolved
import { ResearchAchievementPageQuery } from 'graphql-types';
import { SEO } from '../components/seo';

interface PageProps {
  data: ResearchAchievementPageQuery;
}

const Page: FC<PageProps> = ({ data }) => (
  <Layout>
    <SEO
      title="学術実績"
      description="私たちは犬と猫の腫瘍に関する学会発表や研究も真摯に取り組んでおります。"
      keywords="学術実績"
    />
    <article css={pageBaseStyle}>
      <h1>学術実績 - Research achievement -</h1>
      <div css={skewBorder}></div>
      <section>
        <h2>学会口頭発表</h2>
        <ul>
          <li>
            2010年&nbsp;鉄欠乏性貧血を起こした小腸腺癌の犬の１例&nbsp;動物臨床医学会年次大会
          </li>
          <li>
            2011年&nbsp;外科手術を行った原発性上皮小体機能亢進症の犬の１例&nbsp;日本臨床獣医学フォーラム
          </li>
          <li>
            2013年&nbsp;犬の脾臓腫瘤癌３１症例の回顧的研究（2007～2013年）&nbsp;日本獣医がん学会
          </li>
          <li>
            2015年&nbsp;３歳齢で pseudo-Meigs
            症候群を呈した卵巣腺癌の犬の１例日本獣医麻酔外科学会
          </li>
          <li>
            2015年&nbsp;外科切除にて長期間生存した高悪性度Ｔ細胞性消化器型リンパ腫の犬の１例&nbsp;日本獣医がん学会
          </li>
          <li>
            2016年&nbsp;眼内腫瘤を主訴に来院した播種性組織球肉腫の犬の１例&nbsp;日本獣医がん学会
          </li>
          <li>
            2017年&nbsp;犬の高悪性度消化器型リンパ腫１０症例の回顧的&nbsp;日本獣医がん学会
          </li>
          <li>
            2018年&nbsp;腰椎に発生を認めた全身性肥満細胞症の猫の１例&nbsp;日本獣医がん学会
          </li>
          <li>
            2019年&nbsp;不完全切除の線維肉腫に対し拡大切除を実施した犬の１例&nbsp;日本獣医がん学会
          </li>
          <li>
            2021年&nbsp;Modified Dorsolateral and Intraoral
            Approachを実施した尾側上顎骨アミロイド産生性歯原性腫瘍の犬の1例&nbsp;日本獣医麻酔外科学会
          </li>
          <li>
            2021年&nbsp;心基底部腫瘍に起因した二次性乳び胸の犬の１例&nbsp;動物臨床医学会
          </li>
          <li>
            2022年&nbsp;術後にオーダーメイド化学療法を実施した前立腺癌の犬の1例&nbsp;日本獣医がん学会
          </li>
          <li>
            2022年&nbsp;排便困難に対する緩和的リンパ節切除を実施した犬の1例&nbsp;日本獣医がん学会
          </li>
          <li>
            2023年&nbsp;肝芽腫の犬の1例&nbsp;日本獣医がん学会
          </li>
          <li>
            2025年&nbsp;猫の大細胞性消化器型リンパ腫に対するL-アスパラギナーゼ連続投与の有用性の検討
          </li>
          <li>
            2025年&nbsp;猫の胸腺腫における肋間開胸の有用性： 5症例&nbsp;日本獣医麻酔外科学会
          </li>
        </ul>
      </section>
      <section>
        <h2>著書</h2>
        <ul>
          <li>
            2017年　犬の高悪性度消化器型リンパ腫１０症例の回顧的　ＪＯＮＣＯＬ　No,24
          </li>
          <li>
            2019年　腰椎に発生を認めた全身性肥満細胞症の猫の１例　ＪＯＮＣＯＬ　No,27
          </li>
          <li>
            2020年　不完全切除の線維肉腫に対し拡大切除を実施した犬の1例　ＪＯＮＣＯＬ　No,28
          </li>
          <li>
            2022年　術後にオーダーメイド化学療法を実施した前立腺癌の犬の1例　ＪＯＮＣＯＬ　No,32
          </li>
          <li>
            2023年　排便困難に対する緩和的リンパ節切除を実施した犬の1例　ＪＯＮＣＯＬ　No,33
          </li>
          <li>
            2023年　施設間連携〜どうしてる？症例の紹介〜　ＪＯＮＣＯＬ　No,34
          </li>
          <li>
            2025年　猫の肥満細胞腫オーバービュー　ＪＯＮＣＯＬ　No,38
          </li>
          <li>
            2025年　猫の乳腺腫瘍　CLINIC NOTE　2025年10月号
          </li>
          <li>
            2026年　FNA？生検？切除？部位別に学ぶ腫瘤性病変　診断の分岐点「体表腫瘤」　ＣＡＰ　2026年3月号
          </li>
          <li>
            2026年　犬と猫の胸腺腫　CLINIC NOTE　2026年4月号
          </li>
        </ul>
      </section>
      <section>
        <h2>講演</h2>
        <ul>
          <li>What is your diagnosis? 脾臓の多発性結節　VETS CHANNEL</li>
          <li>What is your diagnosis? 犬の大腿部皮下腫瘤　VETS CHANNEL</li>
          <li>
            what is your diagnosis? 犬の体表リンパ節腫大　診断　VETS CHANNEL
          </li>
          <li>
            what is your diagnosis? 犬の体表リンパ節腫大　治療　VETS CHANNEL
          </li>
          <li>2022年　日本獣医がん学会　総合教育口演　治療学総論</li>
          <li>2024年　東京都獣医師会　城北支部　腫瘍セミナー緩和ケア</li>
          <li>2024年　日本獣医がん学会　総合教育口演　治療学総論</li>
          <li>2024年　第26回JBVP年次大会　愛玩動物看護師の知っておくべき抗がん剤の基礎知識</li>
          <li>2025年　日本獣医がん学会　猫の肥満細胞腫</li>
          <li>2025年　第27回JBVP年次大会　市民プログラム　うちの子が「がん」になったとき　怖くない抗がん剤・怖くない手術</li>
          <li>2025年　第27回JBVP年次大会　エキスパート　腫瘍科医✕画像診断医&nbsp;コラボ企画　一胸部腫瘍一</li>
          <li>2025年　神奈川県獣医師会　中央支部　腫瘍セミナー緩和ケア・緩和手術</li>
          <li>2026年　日本獣医がん学会　組織球系の腫瘍</li>
        </ul>
      </section>
      <section>
        <h2>原著論文</h2>
        <ul>
          <li css={publicationItem}>
            <span css={publicationDate}>2026年4月</span>
            <div css={publicationBody}>
              <strong>
                Evaluation of intercostal thoracotomy as a surgical approach for feline thymoma: A case series of seven cats.
              </strong>
              <div css={publicationMeta}>
                Ikeda Y, Kawana A. <em>Open Vet J</em>. 2026 Apr;16(4):2378-2384. doi: 10.5455/OVJ.2026.v16.i4.39. Epub 2026 Apr 30. PMID: 42375966; PMCID: PMC13314067.
              </div>
            </div>
          </li>
        </ul>
      </section>
    </article>
  </Layout>
);
export default Page;

const pageBaseStyle = css`
  padding: 1rem 4rem;

  @media (max-width: 560px) {
    padding: 1rem !important; // TODO: index.scss撲滅 撲滅次第importantを削除する
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  p {
    margin-bottom: 1.3rem;
  }

  section {
    margin-top: 2rem;
  }

  h1 {
    text-align: center;
    margin-top: 2rem;
    font-size: 1.5rem;
  }

  h2 {
    border-left: solid 0.8rem #80d8ff;
    margin-top: 4rem;
    margin-bottom: 1rem;
    padding-left: 0.5rem;
    font-size: 1.2rem;
    letter-spacing: 0.1rem;
    font-weight: bold;
    clear: both;
  }

  h3 {
    margin-top: 1.5rem;
    margin-bottom: 0.5rem;
    font-size: 1rem;
  }
`;

const skewBorder = css`
  width: 50%;
  height: 0.5rem;
  margin: 1rem auto 0;
  background-color: #80d8ff;
  background-image: repeating-linear-gradient(
    -45deg,
    #fff,
    #fff 7px,
    transparent 0,
    transparent 14px
  );

  @media (max-width: 560px) {
    width: 100%;
  }
`;

const publicationItem = css`
  display: flex;
  align-items: baseline;
  gap: 0.5em;
`;

const publicationDate = css`
  flex-shringk: 0;
  white-space: nowrap;
`;

const publicationBody = css`
  min-width: 0;
`;

const publicationMeta = css`
  font-size: 0.9em;
  color: #666;
`;

export const query = graphql`
  query ResearchAchievementPage {
    site {
      siteMetadata {
        title
      }
    }
  }
`;
